import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import store from './store'
import router from './router'
import './assets/css/style.css'
import './assets/css/fix.css'
import './components/common/index'
import moment from 'moment'
import './directives'
moment.locale('zh-cn')

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
